function Dipespsistemaabastecimineto() {
    return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Sistema Nacional de Abastecimiento 
                    brinda formación técnica y actualizada sobre la normativa, procesos 
                    y herramientas que regulan la gestión de abastecimiento en el sector público.
               </p>
               <p>
                    El programa desarrolla contenidos vinculados a la programación multianual 
                    de bienes, servicios y obras, gestión de requerimientos, planificación 
                    de contrataciones, administración de almacenes, control patrimonial 
                    y articulación con los sistemas administrativos del Estado.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias técnicas para aplicar adecuadamente 
                            la normativa y los procesos del Sistema Nacional de Abastecimiento, 
                            garantizando una gestión eficiente, transparente y articulada 
                            con los demás sistemas administrativos.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img 
                    src='/uploads/curs_sistema_nacional_abastecimiento.jpg' 
                    alt='logo-de-metodologia' 
                    className='logo-metodologia'
                />
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 Teléfonos y WhatsApp: 913376365 / 948251685</p>
                        <p>📧 Correos: esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Marco Normativo del Sistema de Abastecimiento </li>
                    <li> 2. Programación Multianual de Bienes y Servicios </li>
                    <li> 3. Gestión de Requerimientos </li>
                    <li> 4. Planificación de Contrataciones </li>
                    <li> 5. Administración de Almacenes </li>
                    <li> 6. Control Patrimonial </li>
                    <li> 7. Articulación con Sistemas Administrativos </li>
                </ul>
            </div>
        </div>
    );
}
export default Dipespsistemaabastecimineto
